import React, { useState, useEffect } from 'react';
import { API } from '../../../../../API/API';
import ButtonSecondary from '../../../../../components/ButtonSecondary/ButtonSecondary';
import ButtonDefault from '../../../../../components/ButtonDefault/ButtonDefault';
import FieldText from '../../../../../components/FieldText/FieldText';
import { message } from 'antd';
import { MessageConst } from '../../../../../const/MessageConst';
import FieldDate from '../../../../../components/FieldDate/FieldDate';
import PanelBase from '../../../../../components/PanelBase/PanelBase';
import FieldItemListAdd from '../../../../../components/FieldItemListAdd/FieldItemListAdd';
import LoadSpin from '../../../../../components/LoadSpin/LoadSpin';

const NewCert = (props) => {

    const [initData] = useState({
        "entryid": -1,
        "empid": props.empid,
        "certificatedate": null,
        "certificateno": null,
        "note": null,
        "expirydate": null,
        "sourcetype": null,
        "sourceid": null,
        "certificateid": null,
        "organization": null,
        "timedays": null
    });

    const [data, setData] = useState({ ...initData });
    const [warning, setWarning] = useState();
    const [checkRule, setCheckRule] = useState(false);

    const [loading, setLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);

    const getExistData = async () => {
        let tData = { ...initData };
        if (props.entryid) {
            try {
                setLoading(true);
                await API.get('/api/humanresource/employee/get_empcertificate?entryid=' + props.entryid).then(response => {
                    if (response.status == 200 && response.data.rettype == 0) {
                        if (response.data?.retdata?.length > 0) {
                            tData = response.data.retdata[0];
                        }
                    }
                });
            } finally {
                setLoading(false);
            }
        }

        setCheckRule(false);
        setData(tData);
    }

    useEffect(() => {
        getExistData();
    }, [props.entryid]);

    const fieldOnChanged = (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }
            setData(tData);
        }
    }

    const onSave = async (p_close) => {

        setCheckRule(true);

        let vRule = true;

        if (!data.certificateid) {
            vRule = false;
            setWarning("Гэрчилгээ" + MessageConst.fieldRequired);
        } else if (!data.certificateno) {
            vRule = false;
            setWarning("Гэрчилгээний дугаар" + MessageConst.fieldRequired);
        }

        if (vRule) {

            let tData = { ...data };
            tData.empid = props.empid;
            try {
                setLoadingSave(true);
                await API.post('/api/humanresource/employee/save_empcertificate', [tData]).then(response => {
                    if (response.status == 200 && response.data.rettype == 0) {
                        message.success(MessageConst.success);
                        setData({ ...initData });
                        setWarning();
                        if (props.afterSave) {
                            props.afterSave(p_close);
                        }
                    }
                });
            } finally {
                setLoadingSave(false);
            }

        }
    }
    const onDelete = async (p_close) => {
        await API.post('/api/humanresource/employee/delete_empcertificate?entryid=' + props.entryid).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                message.success(MessageConst.success);
                if (props.afterSave) {
                    props.afterSave(p_close);
                }
            }
        });
    }

    return (
        <PanelBase
            headerText={props.entryid > 0 ? "Гэрчилгээ засах" : "Гэрчилгээ нэмэх"}
            isOpen={props.onOpen}
            isFooterAtBottom={true}
            onDismiss={props.onDismiss}
            onDelete={() => onDelete(true)}
            warning={warning}
            delete={props.entryid}
            buttons={
                loadingSave ? <LoadSpin /> : (
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <div>
                            <ButtonSecondary onClick={() => onSave(false)} text="Хадгалаад шинэ" />
                        </div>
                        <div style={{ marginLeft: 16 }}>
                            <ButtonDefault onClick={() => onSave(true)} text="Хадгалах" />
                        </div>
                    </div>
                )
            }
        >
            <div style={{ marginTop: 20 }}>
                <FieldItemListAdd loading={loading} required title="Гэрчилгээ" onChanged={fieldOnChanged} keyfield='certificateid' keyfieldname='certificatename' defaultValue={[{ key: data.certificateid, name: data.certificatename }]} dataurl="/api/humanresource/organization/get_certificate_dropdown" saveurl="/api/humanresource/organization/save_certificate" checkreq={checkRule} />
                <div style={{ marginTop: 13 }}>
                    <FieldText loading={loading} required title="Гэрчилгээний дугаар" onChanged={fieldOnChanged} keyfield='certificateno' defaultValue={data.certificateno} checkreq={checkRule} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDate loading={loading} title="Элссэн огноо" onChanged={fieldOnChanged} keyfield='certificatedate' defaultValue={data.certificatedate} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDate loading={loading} title="Төгссөн огноо" onChanged={fieldOnChanged} keyfield='expirydate' defaultValue={data.expirydate} />
                </div>
            </div>
        </PanelBase>

    );
}

export default NewCert;